import { axiosInstance } from "@/services/axiosInstance";

export const PayoutLotResource = {
  getLista: parametros => {
    return axiosInstance.get("v1/payout/payoutlot", {
      params: parametros
    });
  },

  getListaSoma: parametros => {
    return axiosInstance.get("v1/payout/payoutlot/totals", {
      params: parametros
    });
  },


  getById: parametros => {
    return axiosInstance.get("v1/payout/payoutlot/:id", {
      urlParams: parametros
    });
  },

  update: parametros => {
    return axiosInstance.put("v1/payout/payoutlot", parametros);
  },

  getPayoutLottReceivable: parametros => {
    return axiosInstance.get("v1/payout/payoutlot/:idpayoutlot/receivables", {
      urlParams: parametros
    });
  },

  getPayoutLotLiquidationSummary: parametros => {
    return axiosInstance.get("v1/payout/payoutlot/liquidationSummary", {
      params: parametros
    });
  },

  getCnabPayout: parametros => {
    return axiosInstance.get("v1/payout/cnabpayout", {
      params: parametros
    });
  },

  getCnabPayoutById: parametros => {
    return axiosInstance.get("v1/payout/cnabpayout/:id", {
      urlParams: parametros
    });
  },

  getCnabPayoutTransfers: parametros => {
    return axiosInstance.get("v1/payout/cnabpayout/:id/transfers", {
      urlParams: parametros,
      params: parametros,
    });
  },

};
